module.exports = __webpack_public_path__ + "media/images/welcome-burger-85269d7238b4ad727a45bf4631423f6e.svg";